<template>
  <div v-if="text" class="cooperation-page__step-description text-colored d-flex" :class="{ closing }">
    <BaseSvg
      class="cooperation-page__step-description-close"
      name="ico-close"
      @click.native="close()"
    />

    <div class="cooperation-page__step-description-icon">
      <BaseSvg name="ico-info"/>
    </div>

    <div v-html="text"/>
  </div>
</template>

<script>
  export default {
    props: {
      text: String
    },

    data() {
      return {
        closing: false
      };
    },

    methods: {
      close() {
        this.closing = true;
        setTimeout(() => this.$emit('close'), 100);
      }
    }
  };
</script>
